import { TextureLoader, Vector3 } from "three";
import {
  CameraArguments,
  CameraFile,
  CameraFileArguments,
  CameraImage,
  ImagePixel
} from ".";
import { CameraData, PlanarConfig } from "../../redux/assets-slice";
import { getEulerInverse } from "../projections";
import { PlanarImageMaterial } from "../rendering";
import missingImagePath from "../textures/misc/no-image-planar.png";

const loader = new TextureLoader();
const missingTexture = loader.load(missingImagePath);

export class PlanarImage extends CameraImage {
  public config: PlanarConfig;

  constructor(...args: CameraArguments) {
    super(...args);
    this.config = this.cameraData.config;
    this.missingTexture = missingTexture;
    this.material = new PlanarImageMaterial(this.config);
  }

  pixelToDirection(pixel: ImagePixel) : Vector3 {
    if (!pixel) return null;

    let x = -1 * (pixel.u - this.config.cx) / this.config.fx;
    let y = (pixel.v - this.config.cy) / this.config.fy;

    let xyz = new Vector3(x, y, 1.0)
      .normalize()
      .multiplyScalar(-1.0);

    let direction = xyz.clone()
      .applyEuler(this.rotation.euler);

    return direction;
  }

  directionToPixel(direction: Vector3) : ImagePixel {
    if (!direction) return null;

    const inverse = getEulerInverse(this.rotation.euler);

    const imageDirection = direction.clone()
      .applyEuler(inverse);

    const xyz = new Vector3()
      .copy(imageDirection)
      .divideScalar(imageDirection.z);

    const u = -xyz.x * this.config.fx + this.config.cx;
    const v = xyz.y * this.config.fy + this.config.cy;

    const padding = 50;
    const outOfBounds = (u < -padding)
      || (v < -padding)
      || (u > (this.config.width + padding))
      || (v > (this.config.height + padding));

    if (outOfBounds) return null;

    return {u, v};
  }
}

export class PlanarCameraFile extends CameraFile {
  constructor(...args: CameraFileArguments) {
    super(...args);
  }

  getNewCamera(data: CameraData) {
    return new PlanarImage(
      this,
      data,
      this.cameraHandler.cameraScene,
      this.cameraHandler.controls.object,
      this.cameraHandler.controls.mouseControls
    );
  }
}